import ReactGA from 'react-ga'
import ym from 'react-yandex-metrika'

function anonceArticleOnMainPage(
  name: string | undefined,
  id: string | number
) {
  ReactGA.ga('send', 'event', 'main', 'article click', name)

  ym('reachGoal', 'article click', {
    'main article click': `Статья ${id}`,
  })
}

function anonceArticleOnArticlePage(
  name: string | undefined,
  id: string | number,
  currentPage: string | undefined
) {
  ReactGA.ga('send', 'event', 'article', 'see also bottom', name)

  ym('reachGoal', 'see also event', {
    'see also event': {
      [`Со статьи ${currentPage}`]: `Статья ${id}`,
    },
  })
}

function anonceCollectionOnCollectionPage(
  current: string | undefined,
  next: string | number
) {
  ym('reachGoal', 'collection click', {
    'collection collection click': {
      [`С подборки ${current}`]: `Подборка ${next}`,
    },
  })
}

// update 1.02.2025
export const collectionCardClick = (id: string, page: keyof typeof texts) => {
  // console.log(page)

  const texts = {
    main: 'main collection click',
    collections: 'all collections click',
  }

  ym('reachGoal', 'collection click', {
    [texts[page]]: `Подборка ${id}`,
  })
}

export const articleCardClick = (id: string, page: keyof typeof texts) => {
  const texts = {
    main: 'main article click',
    articles: 'all articles click',
  }

  ym('reachGoal', 'article click', {
    [texts[page]]: `'Статья ${id}`,
  })
}

export const investCardClick = (type: 'middle' | 'top') => {
  ym('reachGoal', 'go to invest', {
    'go to invest': `from main ${type}`,
  })
}

export const fullPadeCardClick = (type: string) => {
  ym('reachGoal', 'go to invest', {
    'main go to': `${type}`,
  })
}

export const analytinsAnonce = (
  page: string,
  name: string | undefined,
  category: string,
  id: string | number,
  currentPage: string | undefined
) => {
  if (category.indexOf('article') !== -1) {
    switch (page) {
      case 'main':
        anonceArticleOnMainPage(name, id)
        break

      case 'article':
        anonceArticleOnArticlePage(name, id, currentPage)
        break
    }
  } else if (category.indexOf('collection') !== -1) {
    switch (page) {
      case 'main':
        ReactGA.ga('send', 'event', page, 'collection click', name)
        ym('reachGoal', 'collection click', {
          'main collection click': `'Подборка ${id}`,
        })

        break

      case 'collection':
        anonceCollectionOnCollectionPage(currentPage, id)
        break
    }
  }
}
